module.exports = __webpack_public_path__ + "img/24.1efa7e2f.png";